import type { FC } from 'react';
import { useState } from 'react';
import { Tabs, Tab, Typography, Container } from '@material-ui/core';
import Funnel from './Funnel';
import IngresosAtencion from './IngresosAtencion/IngresosAtencion';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const GestionOperativa: FC<any> = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const onChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Container sx={{ p: 0 }}>
            <Typography component="span">{children}</Typography>
          </Container>
        )}
      </div>
    );
  };

  return (
    <>
      <Tabs value={tabIndex} onChange={onChangeTab}>
        <Tab label="Funnel E2E" />
        <Tab label="Ingresos y Atención" />
        <Tab label="Mètricas y Reprocesos" disabled />
        <Tab label="Gestión Usuarios Everis" disabled />
      </Tabs>
      <TabPanel index={0} value={tabIndex}>
        <Funnel />
      </TabPanel>
      <TabPanel index={1} value={tabIndex}>
        <IngresosAtencion />
      </TabPanel>
    </>
  );
};

export default GestionOperativa;
